<div class="cockpit-content">
  <h1>{{ card.title | translate }}</h1>
  <div class="flex-gt-xs-100 m-3" style="margin: 0px !important;">
    <app-chart-download-button (buttonClick)="exportCardData()">
      <h4 translate>{{ tableHeaders[0] }}</h4>
    </app-chart-download-button>

    <div class="table-wrapper">
      <table class="cockpit-table methodics-table">
        <tr>
          <th scope="row">{{ 'i18n.cockpit.card.chart.KennzahlenZurMethodik.geschlechtkoeffizient' | translate }}</th>
          <td>{{ kennzahlenZurMethodik.geschlechterkoeffizient | number: '1.3-3' }}</td>
        </tr>
        <tr>
          <th scope="row">
            {{ 'i18n.cockpit.card.chart.KennzahlenZurMethodik.standardfehlerGeschlechtkoeffizient' | translate }}
          </th>
          <td>{{ kennzahlenZurMethodik.standardfehler | number: '1.3-3' }}</td>
        </tr>
        <tr>
          <th scope="row">{{ 'i18n.cockpit.card.chart.KennzahlenZurMethodik.freiheitgrade' | translate }}</th>
          <td>{{ kennzahlenZurMethodik.freiheitsgrade | numberFormat: crtLocale }}</td>
        </tr>
        <tr>
          <th scope="row" [innerHTML]="'i18n.cockpit.card.chart.KennzahlenZurMethodik.r2' | translate "></th>
          <td>{{ kennzahlenZurMethodik.r2 | number: '1.3-3' }}</td>
        </tr>
      </table>
    </div>
    <span class="title">{{ tableHeaders[1] | translate }}</span>
    <div class="table-wrapper">
      <table class="cockpit-table methodics-table"  >
        <tr>
          <th scope="row">
            <span>{{ 'i18n.cockpit.card.chart.KennzahlenZurMethodik.h0Lohndiff' | translate }}</span><br />
            <span>{{ 'i18n.cockpit.card.chart.KennzahlenZurMethodik.kritischer-t-wert' | translate }}</span>
          </th>
          <td style="vertical-align: bottom;">{{ kennzahlenZurMethodik.hNull1KritischerWert | number: '1.3-3' }}</td>
        </tr>
        <tr>
          <th scope="row">
              <span>{{
                  'i18n.cockpit.card.chart.KennzahlenZurMethodik.alpha-zweiseitig-freiheitgrad' | translate
                }}</span><br>
            <span>{{ 'i18n.cockpit.card.chart.KennzahlenZurMethodik.teststatistik-t' | translate }}</span>
          </th>
          <td style="vertical-align: bottom;">{{ kennzahlenZurMethodik.hNull1Teststatistik | number: '1.3-3' }}</td>
        </tr>
        <tr>
          <th scope="row">{{ 'i18n.cockpit.card.chart.KennzahlenZurMethodik.signifikanz' | translate }}</th>
          <td>{{ kennzahlenZurMethodik.hNull1Signifikanz | yesno }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="table-container">
    <div class="flex-gt-xs-100 m-3" style="margin: 0px !important;">
      <app-geschaetzte-koeffizienten-konfidenzintervalle
        [geschaetzteKoeffKonfidenzintervalle]="koeffKonfidenzintervalle"></app-geschaetzte-koeffizienten-konfidenzintervalle>
    </div>
  </div>
</div>
